/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

import Slider from 'react-slick';
import ScrollMenu from 'react-horizontal-scrolling-menu';

// import StepItem from "../../components/StepItem";

class StillCut extends Component {
  state = {
    select: 0,
    mouseOver: false,
    mouseSlider: false,
    slideIndex: 0,
  };
  _isMounted = false;
  componentDidMount = () => {
    this._isMounted = true;
    const { contentSerial } = this.props.childProps;
    this._getData(contentSerial);
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };
  UNSAFE_componentWillReceiveProps = (nextProps, nextState) => {
    //console.log(this.props.location.pathname)
    //console.log(nextProps.location)
    return (
      this.props.childProps.contentSerial !== nextProps.childProps.contentSerial
    );
    //return true;
  };
  componentWillReceiveProps = (nextProps) => {
    ////console.log(nextProps)
    //console.log(this.props.childProps.contentSerial, nextProps.childProps.contentSerial)

    if (
      this.props.childProps.contentSerial !== nextProps.childProps.contentSerial
    ) {
      this._getData(nextProps.childProps.contentSerial);
    }
  };
  _getData = async (contentSerial) => {
    const { onStillCount } = this.props.childProps;

    if (
      contentSerial === '' ||
      contentSerial === null ||
      contentSerial === undefined
    ) {
      alert('잘못된 경로 또는 URL입니다.');
    } else {
      const result = await this._getDataApi(contentSerial);
      const intReturn = result.data[0].intReturn;
      const stillList = result.data[0].listData;

      if (intReturn === 0) {
        onStillCount(stillList.length);
        if (this._isMounted) {
          this.setState({
            stillList,
          });
        }
      }
    }
  };

  _getDataApi = (contentSerial) => {
    const { apiUrl } = this.props;
    //const { contentSerial } = this.props.childProps;
    ////console.log(apiUrl + '/itemInfo?contentSerial=' + contentSerial)

    return axios(apiUrl + '/stillcut?contentSerial=' + contentSerial)
      .then((response) => response)
      .catch((error) => {
        // alert("스틸컷 데이터를 로드 중 오류가 발생했습니다.");
      });
  };
  _renderItem = () => {
    const { stillList, select } = this.state;

    const list = stillList.map((item, index) => {
      return (
        <img
          src={item.thumb}
          className={select === index ? 'on' : null}
          key={index}
        />
      );
    });
    return list;
  };
  _renderSliderItem = () => {
    const { stillList } = this.state;

    const list = stillList.map((item, index) => {
      return <img src={item.photo} key={index} />;
    });

    return list;
  };
  _onSelect = (key) => {
    //console.log(key)

    this.slider.slickGoTo(key);
    this.setState({
      select: key,
    });
  };
  _onToggleMouse = () => {
    const { mouseOver } = this.state;
    this.setState({
      mouseOver: !mouseOver,
    });
  };
  _onNext = () => {
    this.slider.slickNext();
  };
  _onPrev = () => {
    this.slider.slickPrev();
  };
  _onGoto = (i) => {
    ////console.log(i)
    this.slider.slickGoTo(i);
  };
  _toggleSlider = () => {
    const { mouseSlider } = this.state;
    this.setState({
      mouseSlider: !mouseSlider,
    });
  };

  render() {
    const { stillList, select, mouseOver, mouseSlider } = this.state;

    var settings = {
      dots: false,
      dotsClass: 'slick-dots slick-thumb',
      infinite: true,
      //speed: 100,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      autoplay: false,
      //speed: 3000,
      pauseOnFocus: true,

      //className: 'view_max_img',
      useCSS: true,
      adaptiveHeight: true,
      //fade: true,
      beforeChange: (current, next) => this.setState({ select: next }),
    };

    return (
      <Fragment>
        {stillList ? (
          <div className="detil_group3">
            <h1>
              스틸컷<span>.총 {stillList.length}장</span>
              <div>
                <strong>
                  <em>{parseInt(select) + 1}</em> / {stillList.length}
                </strong>
              </div>
            </h1>
            <div className="seutilkeos_group">
              <div className="seutilkeos_tab">
                <div
                  className="div_ul"
                  onMouseEnter={this._onToggleMouse}
                  onMouseLeave={this._onToggleMouse}
                >
                  <ScrollMenu
                    data={this._renderItem()}
                    arrowLeft={
                      mouseOver ? (
                        <a href="#" className="pre_btn on">
                          이전
                        </a>
                      ) : null
                    }
                    arrowRight={
                      mouseOver ? (
                        <a href="#" className="next_btn on">
                          다음
                        </a>
                      ) : null
                    }
                    //selected={selected}
                    //onSelect={this.onSelect}
                    alignCenter={false}
                    dragging={false}
                    onSelect={this._onSelect}
                  />
                </div>
                {/*
                                <a href="#" className="pre_btn">이전</a>
                                <a href="#" className="next_btn next_btn_on">다음</a>
                                <div className="div_ul">
                                    <img src="/img/detail_img/test_img2.png" className="on" />
                                    <img src="/img/detail_img/test_img2.png"/>
                                    <img src="/img/detail_img/test_img2.png"/>
                                    <img src="/img/detail_img/test_img2.png"/>
                                    <img src="/img/detail_img/test_img2.png"/>
                                    <img src="/img/detail_img/seutilkeos_tab_img.png"/>
                                    <img src="/img/detail_img/seutilkeos_tab_img.png"/>
                                </div>
                            */}
              </div>

              <div
                className="seutilkeos_img"
                onMouseEnter={this._toggleSlider}
                onMouseLeave={this._toggleSlider}
              >
                {mouseSlider ? (
                  <Fragment>
                    <a
                      style={{ cursor: 'pointer' }}
                      className="pre_btn"
                      onClick={this._onPrev}
                    >
                      이전
                    </a>
                    <a
                      style={{ cursor: 'pointer' }}
                      className="next_btn"
                      onClick={this._onNext}
                    >
                      다음
                    </a>
                  </Fragment>
                ) : null}

                <Slider ref={(ref) => (this.slider = ref)} {...settings}>
                  {stillList ? this._renderSliderItem() : null}
                </Slider>
              </div>
            </div>
          </div>
        ) : null}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(StillCut));
